module.exports = __webpack_public_path__ + "static/media/brandgefahr.21ab4071.svg";